// extracted by mini-css-extract-plugin
export var fill = "StoryblokVideo-module--fill--ukSmP";
export var hasStarted = "StoryblokVideo-module--hasStarted--eayA1";
export var placeholder = "StoryblokVideo-module--placeholder--G3g2g";
export var posterImage = "StoryblokVideo-module--posterImage--nhagd";
export var wrapper = "StoryblokVideo-module--wrapper--4cEVX";